import {
  DropdownCreatable as DfhDropdownCreatable,
  PrimaryButton,
  RadioButton,
  RadioButtonGroup as DfhRadioButtonGroup,
  SecondaryButton as DfhSecondaryButton,
} from '@designsforhealth/dfh-react-components'
import { Typography } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import Link from 'gatsby-link'
import styled, { css, keyframes } from 'styled-components'

import LoginToSeePrice from '../LoginToSeePrice'

export const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.component.link};

  &:active,
  &:visited {
    color: ${({ theme }) => theme.colors.component.link};
  }
`

export const ErrorMessage = styled(Typography)`
  font-size: 0.75rem;
  margin-top: 10px;
  margin-bottom: 0;
  color: ${({ theme }) => theme.colors.semantic.error};
`

export const HelperTextEditIcon = styled(EditIcon)`
  && {
    font-size: 1.25em;
    margin-right: 0.4em;
    vertical-align: -0.15em;
  }
`

export const DisabledAddToCartButton = styled(PrimaryButton)(
  ({ theme }) => css`
    background: ${theme.colors.grayscale.gray20};
  `,
)

export const AddToEScript = styled(DfhSecondaryButton)(({ theme, disabled }) =>
  disabled
    ? css`
        --btn-line-height: 25px;
        border: 1px solid ${theme.colors.grayscale.gray20};
        color: ${theme.colors.grayscale.white};
        background-color: #0b2648cc;
        font-size: 16px;
        text-transform: none;
      `
    : css`
        --btn-line-height: 25px;
        font-family: ${theme.fontFamilies.robotoCondensed};
        font-size: 16px;
        font-weight: 700;
        text-transform: none;
        transition:
          color 0.15s ease-in-out,
          background-color 0.15s ease-in-out,
          border-color 0.15s ease-in-out,
          box-shadow 0.15s ease-in-out;
        &:hover {
          background-color: #0b2648cc;
          color: ${theme.colors.grayscale.white};
        }
      `,
)

export const DisabledPrescribeButton = styled(DfhSecondaryButton)(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.grayscale.gray20};
    color: ${theme.colors.grayscale.gray40};
  `,
)

const shakeAnimationEnter = keyframes`
  from {
    transform: translate(1px, 1px) rotate(0deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  to {
    transform: translate(1px, -2px) rotate(0deg);
  }
`
const shakeAnimationUpdate = keyframes`
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(0deg);
  }
`

export const ShakableLoginToSeePrice = styled(LoginToSeePrice)<{ toggle: boolean }>`
  font-size: 16px;
  line-height: 170%;
  margin: 20px 0 0;
  transform: translate(0, 0) rotate(0deg);
  animation: ${({ toggle }) =>
    toggle
      ? css`
          ${shakeAnimationEnter} linear forwards 500ms
        `
      : css`
          ${shakeAnimationUpdate} linear forwards 500ms
        `};
`

export const RadioButtonGroup = styled(DfhRadioButtonGroup)`
  ${RadioButton} {
    flex-basis: 100%;
    input:checked + label {
      background-color: #f5f6f8;
    }
    :first-of-type label {
      border-left: 1px solid ${({ theme }) => theme.colors.grayscale.gray10};
    }
    label {
      flex-wrap: nowrap;
      border: 1px solid ${({ theme }) => theme.colors.grayscale.gray10};
      border-left: none;
    }
  }
`

export const AddToCart = styled(PrimaryButton)<{ $ctaColor?: string }>`
  --btn-line-height: 19px;
  max-height: 50px;
  background-color: ${({ theme, $ctaColor }) =>
    $ctaColor ?? theme.colors.component.backgroundDarkBlue};
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-size: 16px;
  font-weight: 700;
  text-transform: none;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  &:hover {
    background-color: #0b2648cc;
  }
`

export const AutoShipText = styled.div`
  color: ${({ theme }) => theme.colors.grayscale.black};
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  font-size: 12px;
  margin-bottom: 24px;
  line-height: normal;
`

export const DropdownCreatable = styled(DfhDropdownCreatable)`
  font-size: 14px;
  margin-bottom: 0;
  .react-select__value-container {
    justify-content: center;
  }
  .react-select__control {
    min-height: 50px;
  }
`
